import type { RouteObject } from "react-router-dom";
import SiteLayout from "@/components/feature/SiteLayout";
import Home from "@/pages/home/page";
import Channels from "@/pages/channels/page";
import LiveDetail from "@/pages/live/page";
import Search from "@/pages/search/page";
import About from "@/pages/about/page";
import Community from "@/pages/community/page";
import Feedback from "@/pages/feedback/page";
import NotFound from "@/pages/NotFound";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <SiteLayout />,
    children: [
      { index: true, element: <Home /> },
      { path: "channels", element: <Channels /> },
      { path: "live/:id", element: <LiveDetail /> },
      { path: "search", element: <Search /> },
      { path: "about", element: <About /> },
      { path: "community", element: <Community /> },
      { path: "feedback", element: <Feedback /> },
      { path: "*", element: <NotFound /> },
    ],
  },
];

export default routes;